module.exports = __webpack_public_path__ + "static/about_mapa-34ce9852da362c4717ed46f12e799ba3.jpg";